import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { AssessmentComponent } from '../assessment/assessment.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { ResubmitClarifyComponent } from '../resubmit-clarify/resubmit-clarify.component';

@Component({
  selector: 'app-execution',
  templateUrl: './execution.component.html',
  styleUrls: ['./execution.component.css']
})
export class ExecutionComponent implements OnInit {
  @Input() executionList: any;
  @Input() ifAssesment: any;
  quesLanguage!: string;
  assessment!: any;
  subscription!: Subscription;
  assessmentDetails: any;
  isArabic!: boolean;
  modalRef!: BsModalRef;
  isChecker = this.storageService.getSessionStorageData('isChecker');
  isMakerCheckerEnabled: any;
  userDetails: any;
  rejectedQuestionsCount: any;
  fetchTotalNoOfQuesResponse!: any;
  @Input() rejectedAssessmentsCount: number = 0;
  isAssessmentStarted!: boolean;
  @Input() isResubmitRejectedAssessment: boolean = false;

  constructor(private activateRoute: ActivatedRoute, private route: Router,
    private assessmentService: AssessmentService,
    private storageService: StorageService,
    private commonService: CommonService,
    private modalService: BsModalService) {
  }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    //this.calculateRejectedQuestions();
    // if (this.isResubmitRejectedAssessment) {
    //   this.calculateRejectedAssessments();
    // }
  }



  subscribeToEmitter(componentRef: any) {
    if (!(componentRef instanceof AssessmentComponent ||
      componentRef instanceof ResubmitClarifyComponent)) {
      return;
    }
    const child: any = componentRef;
    this.subscription = child.questionnaireEvent.subscribe((data: any) => {
      // console.log('assessment details in execution: ', data);
      if (data) {
        this.assessment = JSON.parse(data);
        this.assessmentDetails = {
          questionnaireName: this.assessment.questionnaireName,
          questionnaireguid: this.assessment.questionnaireMdeValue,
          questionnaireProgress: this.assessment.questionnaireProgress,
          assessmentUnit: this.assessment.assessmentUnit.name,
          assessmentunitguid: this.assessment.assessmentUnit.value,
          targetDate: this.assessment.targetDate,
          questionnaireAccountGuid: this.assessment.questionnaireAccountGuid,
        }
        this.storageService.setSessionStorageData('quesStatus', this.assessmentDetails?.questionnaireProgress);
        let rqstBody = {
          questionnaire: this.assessment.questionnaireMdeValue,
          assessmentUnit: this.assessment.assessmentUnit.value,
          isChecker: this.isChecker,
          isMakerCheckerEnabled: this.isMakerCheckerEnabled
        };
        this.assessmentService.fetchTotalNoOfQues(rqstBody).subscribe((res) => {
          let decryptedData = this.commonService.decryptUsingAES256(res?.data);
          let resp = JSON.parse(JSON.stringify(decryptedData));
          //console.log('finally number of questions: ', resp);
          let progressDetails = resp;
          progressDetails.questionnaireProgress = this.assessmentDetails.questionnaireProgress;
          progressDetails.assessmentName = this.assessmentDetails.questionnaireName;
          this.assessmentDetails['totalQues'] = resp.totalQuestions;
          this.assessmentDetails['answeredCount'] = resp.totalAnswers;
          if (resp.totalAnswers > 0) {
            this.isAssessmentStarted = true;
          } else {
            this.isAssessmentStarted = false;
          }
          // console.log("setting assessmentDetails",this.assessmentDetails)
          this.storageService.setSessionStorageData('assessmentDetails', this.assessmentDetails);

          this.storageService.setSessionStorageData('answeredQues', this.assessmentDetails?.answeredCount);
          this.storageService.setSessionStorageData('totalQues', this.assessmentDetails?.totalQues);
        });
      } else {
        this.assessment = null;
      }
    });
  }


  goToGeneralAssessment() {
    if (!this.isAssessmentStarted) {
      let req = {
        questionnaire: this.assessment.questionnaireAccountGuid,
      }
      this.assessmentService.startAssessment(req).subscribe((res) => {
        // console.log('[DEBUG] Received encrypted response:', res);

        let decryptedData;
        try {
          decryptedData = this.commonService.decryptUsingAES256(res?.data);
          // console.log('[DEBUG] Decrypted response data:', decryptedData);
        } catch (error) {
          console.error('[ERROR] decryption failed:', error);
          return;  // Optionally, handle error here
        }

        
      });

    }
    let rqstBody = {
      questionnaire: this.assessmentDetails.questionnaireguid,
      assessmentUnit: this.assessment.assessmentUnit.value,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled
    };
    // console.log(rqstBody, "request")
    this.assessmentService.fetchTotalNoOfQues(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      this.fetchTotalNoOfQuesResponse = resp;
      // console.log('finally number of questions: ', resp);
      if (resp.totalQuestions <= 0) {
        let message;
        if (this.isArabic) {
          message = 'لا يوجد سؤال متاح لهذا التقييم.';
        } else {
          message = 'No question is available for this assessment.';
        }
        let pathUrl = '';
        const initialState = {
          message: message,
          redirectTo: pathUrl
        };
        this.modalRef = this.modalService.show(NotificationComponent, { initialState });
      } else {

        if (resp?.totalEachTypeQuestions?.length > 0) {

          if (!this.isResubmitRejectedAssessment) {
            if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].name == "General" &&
              this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].totalcount > 0) {
              this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General' } });
            }
            else if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].name == "Inherent Risk" &&
              this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].totalcount > 0) {
              this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Inherent Risk' } });
            }
            else if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].name == "Controls" &&
              this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].totalcount > 0) {
              this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Controls' } });
            }
            else {
              this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General' } });
            }
          }
          else if (this.isResubmitRejectedAssessment) {
            if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].name == "General" &&
              this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].totalcount > 0 &&
              (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].draft > 0 ||
                this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[0].rejected > 0)
            ) {
              this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General', action: 'resubmit' } });
            }
            else if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].name == "Inherent Risk" &&
              this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].totalcount > 0 &&
              (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].draft > 0 ||
                this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[1].rejected > 0)
            ) {
              this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Inherent Risk', action: 'resubmit' } });
            }
            else if (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].name == "Controls" &&
              this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].totalcount > 0 &&
              (this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].draft > 0 ||
                this.fetchTotalNoOfQuesResponse?.totalEachTypeQuestions[2].rejected > 0)
            ) {
              this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Controls', action: 'resubmit' } });
            }
            else {
              this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General', action: 'resubmit' } });
            }
          }
        }
      }
    });
  }

  onListItemClick(selectedItemIdx: number) {
    this.executionList.forEach((v: any, i: any) => {
      if (i === selectedItemIdx) {
        v.isActive = true;
      } else {
        v.isActive = false;
      }
    });
    this.ifAssesment = this.executionList[selectedItemIdx]?.link === 'assessment';
    if (this.executionList[selectedItemIdx].link !== '') {
      let path = 'executor-dashboard/' + this.executionList[selectedItemIdx].link;
      this.route.navigate([path]);
    }

  }

  calculateRejectedQuestions() {
    const rqstBody = { assessmentUnit: this.userDetails?.assessmentUnitValue };
    if (this.isMakerCheckerEnabled) {
      this.assessmentService.fetchRejectedQuestions(rqstBody).subscribe((res) => {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        //console.log('get rejected questions: ', decryptedData);
        let rejectedList = JSON.parse(JSON.stringify(decryptedData));
        //console.log('rejectedList: ', rejectedList);
        this.rejectedQuestionsCount = rejectedList.rejectedQuestions.length;
      });
    } else {
      this.assessmentService.fetchSupervisorRejectedQuestions(rqstBody).subscribe((res) => {
        if (res?.data) {
          let decryptedData = this.commonService.decryptUsingAES256(res?.data);
          //console.log('get rejected questions: ', decryptedData);
          let rejectedList = JSON.parse(JSON.stringify(decryptedData));
          //console.log('rejectedList: ', rejectedList);
          this.rejectedQuestionsCount = rejectedList.rejectedQuestions.length;
        } else {
          //console.log('error 2: ', res);
        }
      });
    }
  }

}
